
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Patient = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M17.1,12.5H14l-1.5,1.9L11,12.5H7.9a2.3,2.3,0,0,0-2.3,2.3v7.4H19.4V14.8A2.3,2.3,0,0,0,17.1,12.5Zm.8,8.2H7.1V14.8a.8.8,0,0,1,.8-.8h2.4l2.2,2.8L14.7,14h2.4a.8.8,0,0,1,.8.8Z"></path>
            <path d="M12.5,11.1a4.2,4.2,0,0,0,4.2-4.2,4.2,4.2,0,0,0-8.4,0A4.2,4.2,0,0,0,12.5,11.1Zm0-6.8A2.7,2.7,0,1,1,9.8,6.9,2.7,2.7,0,0,1,12.5,4.3Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Patient.defaultProps = {
  title: 'Patient',
};

export default Patient;
